import { FC } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EUR1 from '@/components/UI/svg/delta2max/EUR1';
import EUR3 from '@/components/UI/svg/delta2max/EUR3';
import EUR4 from '@/components/UI/svg/delta2max/EUR4';
import NextImage from '@/components/NextImage';

export const ZIComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`${css.ZIComp} GtmModuleData-section`} data-section-id={css.ZIComp} data-section-title={t('sec18_title1')}>
            <div className="intro-list">
                <div className="intro-list-1">
                    <div className="intro-item">
                        <div className="icon">
                            <EUR1 />
                        </div>
                        <div className="subtitle">{t('sec18_subtitle1')}</div>
                        <div className="title">{t('sec18_title1')}</div>
                        <div className="desc">{t('sec18_desc1')}</div>
                    </div>
                    <div className="intro-item intro-item-r">
                        <div className="icon">
                            <div style={{ width: '52px', height: '52px' }}>
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec16_icon.webp')}
                                    src={require('@publicLocal/delta2max/detail/pc/sec16_icon.png')}
                                />
                            </div>
                        </div>
                        <div className="subtitle">{t('sec18_subtitle2')}</div>
                        <div className="title">{t('sec18_title2')}</div>
                        <div className="desc">{t('sec18_desc2')}</div>
                    </div>
                </div>
                <div className="intro-list-2">
                    <div className="intro-item">
                        <div className="icon">
                            <EUR3 />
                        </div>
                        <div className="subtitle">{t('sec18_subtitle3')}</div>
                        <div className="title">{t('sec18_title3')}</div>
                        <div className="desc">{t('sec18_desc3')}</div>
                    </div>
                    <div className="intro-item intro-item-r">
                        <div className="icon">
                            <EUR4 text={t('sec18_icon_text')} />
                        </div>
                        <div className="subtitle">{t('sec18_subtitle4')}</div>
                        <div className="title">{t('sec18_title4')}</div>
                        <div className="desc">{t('sec18_desc4')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
